import { useEffect } from "react";
import { useSession } from "./store";

/** Tell the shell (and the assistant) which project file this page is showing. */
export function usePublishActiveFile(path: string | null) {
  const setActiveFile = useSession((s) => s.setActiveFile);
  useEffect(() => {
    setActiveFile(path);
    return () => setActiveFile(null);
  }, [path, setActiveFile]);
}

/** Consume a one-shot "open this file" request addressed to files under `prefix`. */
export function usePendingOpenFile(prefix: string, onOpen: (path: string) => void) {
  const pending = useSession((s) => s.pendingOpenFile);
  const setPending = useSession((s) => s.setPendingOpenFile);
  useEffect(() => {
    if (pending && pending.startsWith(prefix)) {
      onOpen(pending);
      setPending(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pending, prefix]);
}
